export const HOST = 'https://react.webatsolution.com/admin/';

export const Endpoint = {
    GET_PRODUCT_LISTING: HOST + "/wp-json/wc/v3/products",
    GET_CATEGORY_LISTING_FILTER: HOST + "/wp-json/wc/v3/products/categories",
    ORDER_SUBMIT: HOST + "/wp-json/wc/v3/orders",
    SUBMIT_CONTACT_FORM: HOST + "/wp-json/contact-form-7/v1/contact-forms/2190/feedback",

    HOME_SLIDER_LIST: HOST + "/wp-json/react/v1/slider",

}